// extracted by mini-css-extract-plugin
export default {"capacityDetails":"_4ucJrLlcAqQqIM4CKiauwh"};